(function () {
  var root = document.querySelector('[data-cod]');
  var abrir = document.querySelector('[data-cod-open]');
  if (!root || !abrir || window.__hrCodInit) return;
  window.__hrCodInit = true;

  var API = window.HR_COD_CFG.api;
  var WA = window.HR_COD_CFG.wa;
  var P = JSON.parse(document.querySelector('[data-cod-producto]').textContent);
  var $ = function (s) { return root.querySelector(s); };
  var form = $('[data-cod-form]');
  var qty = 1, variante = null, dsc = null;

  function money(c) { return '$' + Math.round(c / 100).toLocaleString('es-CO'); }
  /* Envío: las tarifas salen de Shopify (cod-api, accion "envio"): las mismas del checkout y las que cobra el
     backend al crear el pedido. Desde el 5-oct-2026: gratis desde $140.000; $8.800 por debajo (desde el 8-oct; antes $15.000); Dropi gratis. */
  var tramos = null, tramosOk = false, envioActual = null;
  function cargaTramos(vid) {
    if (tramosOk || !vid) return;
    tramosOk = true;
    fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ accion: 'envio', variantId: vid }) })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j && j.ok && j.tramos) { tramos = j.tramos; if (variante) { pinta(); notaEnvio(); } } else tramosOk = false; })
      .catch(function () { tramosOk = false; });
  }
  function precioEnvio(cents) {
    if (!tramos) return null;
    var v = cents / 100, ok = tramos.filter(function (t) { return v >= t.min && (t.max == null || v <= t.max); }).map(function (t) { return t.precio; });
    return ok.length ? Math.round(Math.min.apply(null, ok) * 100) : null;
  }
  function gratisDesde() {
    var g = (tramos || []).filter(function (t) { return t.precio === 0 && t.min > 0; }).map(function (t) { return t.min; });
    return g.length ? Math.min.apply(null, g) : null;
  }
  function textoEnvio() {
    if (envioActual === null) return '';
    if (envioActual === 0) return 'Envío gratis a toda Colombia.';
    var g = gratisDesde();
    return 'Envío a toda Colombia: ' + money(envioActual) + (g ? ' (gratis desde ' + money(g * 100) + ').' : '.');
  }
  function notaEnvio() { var n = $('[data-cod-note]'); if (n && typeof pago !== 'undefined' && pago) n.innerHTML = nota(pago); }
  function varianteActual() {
    var inp = document.querySelector('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
    var id = inp ? parseInt(inp.value, 10) : null;
    return P.variants.find(function (v) { return v.id === id; }) || null;
  }
  function tallaElegida() {
    var t = document.querySelector('.sizes .size.is-sel, .sizes .size.is-active, .sizes .size[aria-pressed="true"], .sizes .size.selected');
    var sizes = document.querySelector('.sizes');
    return !sizes || !!t;
  }

  /* Tope de cantidad: el stock real de la talla cuando el inventario está controlado (máx. 5 por pedido) */
  /* ---- Talla dentro del formulario ---- */
  var SIZE_I = (P.options || []).findIndex(function (o) { return /talla|size/i.test(o); });
  var COLOR_I = (P.options || []).findIndex(function (o) { return /color/i.test(o); });
  var tallaOk = true;
  function colorActual() {
    if (COLOR_I < 0) return null;
    if (variante && variante.opts) return variante.opts[COLOR_I];
    var sw = document.querySelector('[data-pdp-colors] .swatch.is-active'); return sw ? sw.getAttribute('data-color') : null;
  }
  function natural(a, b) { var x = parseFloat(a), y = parseFloat(b); return (isNaN(x) || isNaN(y)) ? String(a).localeCompare(String(b)) : x - y; }
  function varianteDeTalla(talla) {
    var color = colorActual();
    return P.variants.find(function (v) { return v.opts && v.opts[SIZE_I] === talla && (COLOR_I < 0 || !color || v.opts[COLOR_I] === color); }) || null;
  }
  function pintaTallas() {
    var cont = $('[data-cod-sizes]'), lbl = $('[data-cod-sizelbl]'), hint = $('[data-cod-sizehint]');
    if (!cont) return;
    if (SIZE_I < 0) { cont.hidden = true; if (lbl) lbl.hidden = true; if (hint) hint.hidden = true; return; }
    var color = colorActual(), vistas = {}, tallas = [];
    P.variants.forEach(function (v) {
      if (!v.opts || (COLOR_I >= 0 && color && v.opts[COLOR_I] !== color)) return;
      var t = v.opts[SIZE_I]; if (!(t in vistas)) { vistas[t] = false; tallas.push(t); }
      if (v.available) vistas[t] = true;
    });
    tallas.sort(natural);
    var sel = (tallaOk && variante && variante.opts) ? variante.opts[SIZE_I] : null;
    cont.innerHTML = tallas.map(function (t) {
      var ok = vistas[t];
      return '<button type="button" class="cod__size' + (t === sel ? ' is-sel' : '') + (ok ? '' : ' is-off') + '" data-cod-size="' + String(t).replace(/"/g, '&quot;') + '"' + (ok ? '' : ' aria-disabled="true" title="Talla agotada"') + ' role="radio" aria-checked="' + (t === sel) + '">' + t + '</button>';
    }).join('');
    if (hint) hint.hidden = !!sel;
    var btn = $('[data-cod-submit]'); if (btn) btn.disabled = !sel;
  }
  function elegirTalla(t) {
    var v = varianteDeTalla(t); if (!v || !v.available) return;
    variante = v; tallaOk = true; qty = 1;
    // sincronizar con la ficha (misma talla seleccionada arriba)
    var pb = document.querySelector('.sizes .size[data-size="' + t.replace(/"/g, '\\"') + '"]');
    if (pb && !pb.classList.contains('is-out') && !pb.classList.contains('is-sel')) pb.click();
    pinta(); pintaTallas(); avisoStock(false);
  }
  function maxQty() { return variante && variante.limitado ? Math.max(0, Math.min(5, variante.stock)) : 5; }
  function avisoStock(intentoSubir) {
    // Escasez REAL (stock de Shopify): desde que se elige una talla con 3 pares o menos se avisa; si intenta pedir más, se explica el tope.
    var m = $('[data-cod-qtymsg]'), max = maxQty();
    if (!variante || !variante.limitado || max > 3) { m.hidden = true; return; }
    var txt = max === 1 ? 'Último par en su talla. Si lo pide hoy, es suyo.' : 'Quedan solo ' + max + ' pares en su talla.';
    if (intentoSubir && qty >= max) txt += max === 1 ? ' Es la única unidad.' : ' No hay más unidades.';
    m.textContent = txt; m.classList.toggle('is-ultimo', max === 1); m.hidden = false;
  }

  /* "Pague en línea o a cuotas": lleva al checkout de Shopify con los datos YA escritos en el formulario
     (correo, nombre, dirección, ciudad, departamento, celular, cédula en el campo "Número de cédula" y el
     código de descuento), para que el cliente no tenga que volver a escribirlos. */
  /* Validación de correo y celular colombiano (10 dígitos, empieza por 3; se admite el 57 delante) */
  function emailValido(s) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(s || '').trim()); }
  function celularDigitos(s) { var d = String(s || '').replace(/\D/g, ''); if (d.length === 12 && d.indexOf('57') === 0) d = d.slice(2); return d; }
  function celularValido(s) { return /^3\d{9}$/.test(celularDigitos(s)); }
  function urlCheckout() {
    if (!variante) return '/cart';
    var fd = form ? new FormData(form) : null, g = function (k) { return fd ? String(fd.get(k) || '').trim() : ''; };
    var dep = form ? form.querySelector('select[name="departamento"]') : null;
    var depNombre = dep && dep.selectedIndex > 0 ? dep.options[dep.selectedIndex].text.trim() : '';
    var dir = [g('direccion'), g('referencia')].filter(Boolean).join(', ');
    var q = [];
    var add = function (k, v) { if (v) q.push(k + '=' + encodeURIComponent(v)); };
    if (emailValido(g('email'))) add('checkout[email]', g('email'));
    add('checkout[shipping_address][first_name]', g('nombre'));
    add('checkout[shipping_address][last_name]', g('apellido'));
    add('checkout[shipping_address][address1]', dir);
    add('checkout[shipping_address][address2]', g('barrio'));
    add('checkout[shipping_address][city]', g('ciudad'));
    add('checkout[shipping_address][province]', depNombre);
    add('checkout[shipping_address][country]', 'Colombia');
    if (celularValido(g('telefono'))) add('checkout[shipping_address][phone]', celularDigitos(g('telefono')));
    add('checkout[shipping_address][company]', g('cedula').replace(/\D/g, ''));   // el checkout usa "Empresa" como Número de cédula
    if (dsc && dsc.codigo) add('discount', dsc.codigo);
    return '/cart/' + variante.id + ':' + qty + (q.length ? '?' + q.join('&') : '');
  }
  var ahorro = 0;
  function pinta() {
    if (qty > maxQty()) qty = Math.max(1, maxQty());
    $('[data-cod-mas]').disabled = qty >= maxQty();
    avisoStock(false);
    var sub = variante.price * qty;
    var d = 0;
    if (dsc && dsc.tipo === 'porcentaje') d = Math.round(sub * dsc.valor);
    else if (dsc && dsc.tipo === 'monto') d = Math.min(sub, Math.round(dsc.valor * 100));
    var total = sub - d;
    envioActual = precioEnvio(total);
    var envTx = envioActual === null ? '…' : envioActual === 0 ? 'Gratis' : money(envioActual);
    var e1 = $('[data-cod-envio]'), e2 = $('[data-cod-envio2]');
    if (e1) e1.textContent = envTx; if (e2) e2.textContent = envTx;
    var totalPagar = total + (envioActual || 0);
    $('[data-cod-title]').textContent = P.title;
    $('[data-cod-vtitle]').textContent = variante.title === 'Default Title' ? '' : variante.title.toUpperCase();
    $('[data-cod-img]').src = variante.image || P.image;
    $('[data-cod-badge]').textContent = qty;
    var cmp = $('[data-cod-compare]');
    if (variante.compare > variante.price) { cmp.textContent = money(variante.compare); cmp.hidden = false; } else cmp.hidden = true;
    $('[data-cod-price]').textContent = money(variante.price);
    $('[data-cod-qty]').textContent = qty;
    $('[data-cod-subtotal]').textContent = money(sub);
    $('[data-cod-dscrow]').hidden = !d;
    $('[data-cod-dsc]').textContent = '-' + money(d);
    $('[data-cod-dscname]').textContent = dsc ? '(' + dsc.codigo + ')' : '';
    $('[data-cod-total]').textContent = money(totalPagar);
    $('[data-cod-btntotal]').textContent = money(totalPagar);
    /* Ahorro = rebaja del producto (precio antes − precio) + código de descuento + calzador
       de regalo (desde 2 pares; cod-api lo agrega al pedido en $0). */
    var conRegalo = !!P.regalo && qty >= 2;
    var ahorroRebaja = variante.compare > variante.price ? (variante.compare - variante.price) * qty : 0;
    ahorro = ahorroRebaja + d + (conRegalo ? (P.regaloPrecio || 0) : 0);
    $('[data-cod-regalorow]').hidden = !conRegalo;
    $('[data-cod-ahorrorow]').hidden = ahorro <= 0;
    $('[data-cod-ahorro]').textContent = money(ahorro);
    $('[data-cod-checkout]').href = urlCheckout();
    var txt = '¡Hola! Quiero pedir este par: ' + P.title + (variante.title !== 'Default Title' ? ' (' + variante.title + ')' : '') + ' — ' + P.url;
    $('[data-cod-wa]').href = 'https://wa.me/' + WA + '?text=' + encodeURIComponent(txt);
    notaEnvio();
  }

  function abrirModal() {
    variante = varianteActual() || P.variants[0];
    if (!variante) return;
    cargaTramos(variante.id);
    if (window.hrEvento) window.hrEvento('cod_abierto');
    // Sin talla elegida en la ficha, o talla agotada: el formulario abre igual y la talla se elige adentro
    tallaOk = SIZE_I < 0 || (tallaElegida() && !!variante.available);
    qty = 1; dsc = null; comprobante = null;
    var rc = root.querySelector('input[name="pago"][value="cod"]'); if (rc && !rc.checked) { rc.checked = true; rc.dispatchEvent(new Event('change')); }
    $('[data-cod-ok]').hidden = true; $('[data-cod-body]').hidden = false;
    var okqr = $('[data-cod-okqr]'); if (okqr) okqr.hidden = true; // pantalla QR: ya no existe en el HTML (se quitó), pero el JS sigue siendo tolerante
    $('[data-cod-err]').hidden = true; $('[data-cod-codemsg]').hidden = true;
    var nEl = $('[data-cod-note]'); if (nEl && pago === 'cod') nEl.innerHTML = nota('cod');
    pinta(); pintaTallas();
    root.hidden = false; root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    try { if (window.fbq) fbq('track', 'InitiateCheckout', { currency: 'COP', value: variante.price * qty / 100, content_ids: [variante.sku || String(variante.id)], content_type: 'product', num_items: qty }); } catch (e) {}
    setTimeout(function () { var f = form.querySelector('input[name="nombre"]'); if (f && window.innerWidth > 640) f.focus(); }, 120);
  }
  function cerrar() { root.hidden = true; root.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

  abrir.addEventListener('click', abrirModal);
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-cod-close]')) { cerrar(); return; }
    var st = e.target.closest('[data-cod-size]');
    if (st) {
      var h = $('[data-cod-sizehint]');
      if (st.classList.contains('is-off')) { if (h) { h.textContent = 'La talla ' + st.getAttribute('data-cod-size') + ' está agotada. Elija otra disponible o escríbanos por WhatsApp.'; h.classList.add('is-err'); h.hidden = false; } return; }
      if (h) { h.classList.remove('is-err'); h.textContent = 'Elija su talla para continuar.'; }
      elegirTalla(st.getAttribute('data-cod-size')); return;
    }
    if (e.target.closest('[data-cod-mas]')) { if (qty + 1 <= maxQty()) { qty += 1; } pinta(); avisoStock(true); }
    if (e.target.closest('[data-cod-menos]')) { qty = Math.max(1, qty - 1); pinta(); avisoStock(false); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) cerrar(); });

  /* Método de pago: contra entrega (por defecto) o pago anticipado por QR */
  var pago = 'cod', comprobante = null;
  var NOTAS = { cod: 'Pague cuando reciba su pedido en casa.', qr: 'Pague ahora por QR con Nequi, Daviplata o Bre-B.<br>Su pedido sale apenas confirmemos el pago.' };
  var SUBS = { cod: 'Pague al recibir', qr: 'Pagar ahora con QR' };
  /* Contra entrega: la fecha estimada (snippet hr-entrega) va en la nota, bajo "pague al recibir". */
  function nota(p) {
    var e = p === 'cod' && window.hrEntrega && window.hrEntrega.calc();
    var env = textoEnvio();
    if (e) return 'Pague cuando reciba su pedido en casa.' + (env ? ' ' + env : '') + '<br>' + e.titulo + '.';
    return NOTAS[p] + (env ? (p === 'cod' ? '<br>' : ' ') + env : '');
  }
  root.querySelectorAll('input[name="pago"]').forEach(function (r) {
    r.addEventListener('change', function () {
      if (!r.checked) return;
      pago = r.value;
      root.querySelectorAll('.cod__payopt').forEach(function (l) { l.classList.toggle('is-sel', l.contains(r)); });
      $('[data-cod-note]').innerHTML = nota(pago); $('[data-cod-btnsub]').textContent = SUBS[pago];
    });
  });

  /* Comprobante de pago: la foto se comprime en el navegador (máx. 1400 px, JPEG) y el backend la guarda en Archivos de Shopify */
  function leerComoDataURL(file) { return new Promise(function (res, rej) { var r = new FileReader(); r.onload = function () { res(r.result); }; r.onerror = rej; r.readAsDataURL(file); }); }
  function comprimirImagen(file) {
    return new Promise(function (res, rej) {
      var img = new Image(), url = URL.createObjectURL(file);
      img.onload = function () {
        var s = Math.min(1, 1400 / Math.max(img.width, img.height));
        var c = document.createElement('canvas'); c.width = Math.round(img.width * s); c.height = Math.round(img.height * s);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height); URL.revokeObjectURL(url);
        res({ data: c.toDataURL('image/jpeg', 0.82), tipo: 'image/jpeg' });
      };
      img.onerror = function () { URL.revokeObjectURL(url); rej(new Error('imagen')); };
      img.src = url;
    });
  }
  var fileIn = $('[data-cod-file]');
  if (fileIn) fileIn.addEventListener('change', function () {
    var f = fileIn.files && fileIn.files[0], msg = $('[data-cod-proofmsg]');
    if (!f || !comprobante) return;
    msg.hidden = false; msg.className = 'cod__proof-msg'; msg.textContent = 'Subiendo comprobante…';
    var esPdf = f.type === 'application/pdf';
    if (esPdf && f.size > 3 * 1024 * 1024) { msg.className = 'cod__proof-msg is-err'; msg.textContent = 'El PDF pesa mucho. Envíe una captura o mándelo por WhatsApp.'; fileIn.value = ''; return; }
    var lectura = esPdf
      ? leerComoDataURL(f).then(function (d) { return { data: d, tipo: 'application/pdf' }; })
      : comprimirImagen(f).catch(function () { return leerComoDataURL(f).then(function (d) { return { data: d, tipo: f.type || 'image/jpeg' }; }); });
    lectura
      .then(function (a) { return fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ accion: 'comprobante', pedidoId: comprobante.pedidoId, firma: comprobante.firma, tipo: a.tipo, archivo: a.data }) }); })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j.ok) { msg.className = 'cod__proof-msg'; msg.textContent = '✓ Comprobante recibido. Le confirmamos por WhatsApp en cuanto verifiquemos el pago.'; }
        else { msg.className = 'cod__proof-msg is-err'; msg.textContent = j.error || 'No pudimos guardar el comprobante. Envíelo por WhatsApp.'; }
      })
      .catch(function () { msg.className = 'cod__proof-msg is-err'; msg.textContent = 'No hubo conexión. Envíe el comprobante por WhatsApp.'; });
    fileIn.value = '';
  });
  var copyBtn = $('[data-cod-copy]');
  if (copyBtn) copyBtn.addEventListener('click', function () {
    var llave = copyBtn.getAttribute('data-llave'), s = copyBtn.querySelector('small');
    function ok() { s.textContent = '¡Copiada!'; setTimeout(function () { s.textContent = 'Copiar'; }, 2000); }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(llave).then(ok, function () { window.prompt('Copie la llave:', llave); });
    else window.prompt('Copie la llave:', llave);
  });

  $('[data-cod-apply]').addEventListener('click', function () {
    var code = $('[data-cod-code]').value.trim().toUpperCase();
    var msg = $('[data-cod-codemsg]');
    if (!code) return;
    msg.hidden = false; msg.className = 'cod__msg'; msg.textContent = 'Validando…';
    fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ accion: 'codigo', codigo: code }) })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j.ok) { dsc = j.descuento; dsc.codigo = j.codigo; msg.textContent = '✓ Código aplicado'; }
        else { dsc = null; msg.className = 'cod__msg is-err'; msg.textContent = j.error || 'Código no válido'; }
        pinta();
      })
      .catch(function () { msg.className = 'cod__msg is-err'; msg.textContent = 'No pudimos validar el código'; });
  });

  function marca(nombre, texto) {
    var el = form.querySelector('[name="' + nombre + '"]'); if (!el) return;
    var f = el.closest('.cod__f') || el.closest('.cod__chk'); if (!f) return;
    f.classList.toggle('is-bad', !!texto);
    var old = f.querySelector('.cod__ferr'); if (old) old.remove();
    if (texto && f.classList.contains('cod__f')) { var s = document.createElement('span'); s.className = 'cod__ferr'; s.textContent = texto; f.appendChild(s); }
  }
  function cookie(n) { var m = document.cookie.match('(?:^|; )' + n + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : null; }
  /* fbc: cookie _fbc o, si aún no existe, se arma con el ?fbclid= del anuncio (formato oficial fb.1.<ms>.<fbclid>) */
  function fbcActual() { var c = cookie('_fbc'); if (c) return c; var m = location.search.match(/[?&]fbclid=([^&#]+)/); return m ? 'fb.1.' + Date.now() + '.' + decodeURIComponent(m[1]) : null; }
  function restauraBtn() { var btn = $('[data-cod-submit]'); btn.disabled = !tallaOk; $('[data-cod-btnlabel]').innerHTML = 'Confirmar pedido - <span data-cod-btntotal></span>'; pinta(); }

  // Aviso inmediato al salir del campo (sin esperar al botón)
  form.addEventListener('focusout', function (e) {
    var el = e.target; if (!el || !el.name) return;
    if (el.name === 'telefono') marca('telefono', el.value.trim() && !celularValido(el.value) ? 'Escriba un celular colombiano: 10 dígitos y empieza por 3' : '');
    if (el.name === 'email') marca('email', el.value.trim() && !emailValido(el.value) ? 'Ese correo no parece válido (ejemplo: nombre@gmail.com)' : '');
  });
  form.addEventListener('input', function () { var a = $('[data-cod-checkout]'); if (a && variante) a.href = urlCheckout(); });
  form.addEventListener('change', function () { var a = $('[data-cod-checkout]'); if (a && variante) a.href = urlCheckout(); });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var btn = $('[data-cod-submit]'), err = $('[data-cod-err]');
    err.hidden = true;
    if (!tallaOk) { var h = $('[data-cod-sizehint]'); if (h) { h.hidden = false; h.scrollIntoView({ behavior: 'smooth', block: 'center' }); } return; }
    ['nombre','apellido','telefono','email','departamento','ciudad','direccion','terminos'].forEach(function (n) { marca(n, ''); });
    var fd = new FormData(form);
    var datos = {
      accion: 'pedido', variantId: variante.id, cantidad: qty, codigo: dsc ? dsc.codigo : '', pago: pago,
      nombre: fd.get('nombre'), apellido: fd.get('apellido'), telefono: fd.get('telefono'), cedula: fd.get('cedula'),
      email: fd.get('email'), departamento: fd.get('departamento'), ciudad: fd.get('ciudad'), barrio: fd.get('barrio'),
      direccion: fd.get('direccion'), referencia: fd.get('referencia'), terminos: !!fd.get('terminos'), website: fd.get('website'),
      url: location.href, fbp: cookie('_fbp'), fbc: fbcActual()
    };
    var faltan = [];
    if (!datos.nombre || datos.nombre.trim().length < 2) faltan.push(['nombre', 'Escriba su nombre']);
    if (!datos.apellido || datos.apellido.trim().length < 2) faltan.push(['apellido', 'Escriba su apellido']);
    if (!celularValido(datos.telefono)) faltan.push(['telefono', 'Escriba un celular colombiano: 10 dígitos y empieza por 3']);
    if (datos.email && !emailValido(datos.email)) faltan.push(['email', 'Ese correo no parece válido (ejemplo: nombre@gmail.com)']);
    if (!datos.departamento) faltan.push(['departamento', 'Elija su departamento']);
    if (!datos.ciudad || datos.ciudad.trim().length < 2) faltan.push(['ciudad', 'Escriba su ciudad']);
    if (!datos.direccion || datos.direccion.trim().length < 5) faltan.push(['direccion', 'Escriba la dirección completa']);
    if (!datos.terminos) faltan.push(['terminos', 'Acepte los términos para continuar']);
    if (faltan.length) {
      faltan.forEach(function (f) { marca(f[0], f[1]); });
      var primero = form.querySelector('.is-bad input, .is-bad select'); if (primero) primero.focus();
      if (!datos.terminos) { err.textContent = 'Acepte los términos y condiciones para continuar.'; err.hidden = false; }
      return;
    }

    btn.disabled = true; $('[data-cod-btnlabel]').textContent = 'Registrando su pedido…';
    fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(datos) })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        restauraBtn();
        if (!j.ok) {
          if (j.maxCantidad) { qty = Math.max(1, j.maxCantidad); pinta(); avisoStock(true); }
          if (j.campos) Object.keys(j.campos).forEach(function (k) { marca(k, j.campos[k]); });
          err.textContent = j.error || 'No pudimos registrar el pedido.'; err.hidden = false;
          err.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        /* Purchase del pixel con los MISMOS datos que el servidor mandó por CAPI (event_id "cod-<pedido>", valor, SKU): Meta los deduplica */
        try {
          if (window.fbq) {
            var px = j.pixel || {};
            fbq('track', 'Purchase', {
              currency: px.currency || 'COP', value: px.value != null ? px.value : j.pedido.total,
              content_ids: px.content_ids || [variante.sku || String(variante.id)], content_type: 'product',
              content_name: px.content_name || P.title, contents: px.contents || [{ id: variante.sku || String(variante.id), quantity: qty, item_price: variante.price / 100 }],
              num_items: px.num_items || qty
            }, { eventID: px.eventId || j.eventoId });
          }
        } catch (e) {}
        if (window.hrEvento) window.hrEvento('cod_enviado');
        $('[data-cod-body]').hidden = true;
        if (j.pago === 'qr' && j.comprobante) {
          comprobante = j.comprobante;
          var tot = money(Math.round(j.pedido.total * 100));
          $('[data-cod-qrname]').textContent = j.pedido.name;
          $('[data-cod-qrtotal]').textContent = tot; $('[data-cod-qrtotal2]').textContent = tot;
          var txq = 'Hola, hice el pedido ' + j.pedido.name + ' (' + P.title + ') por ' + tot + ' y pagué por Nequi/QR. Aquí va el comprobante:';
          $('[data-cod-qrwa]').href = 'https://wa.me/' + WA + '?text=' + encodeURIComponent(txq);
          $('[data-cod-proofmsg]').hidden = true;
          $('[data-cod-okqr]').hidden = false; $('[data-cod-okqr]').scrollTop = 0;
        } else {
          $('[data-cod-okname]').textContent = j.pedido.name;
          var okA = $('[data-cod-okahorro]');
          if (okA) { okA.hidden = ahorro <= 0; okA.innerHTML = 'En este pedido usted ahorró <b>' + money(ahorro) + '</b>.'; }
          $('[data-cod-oktel]').textContent = String(datos.telefono).replace(/\D/g, '').slice(-10);
          var txt = 'Hola, acabo de hacer el pedido ' + j.pedido.name + ' (' + P.title + '). Quiero confirmar la entrega.';
          $('[data-cod-okwa]').href = 'https://wa.me/' + WA + '?text=' + encodeURIComponent(txt);
          $('[data-cod-ok]').hidden = false;
        }
      })
      .catch(function () {
        restauraBtn();
        err.textContent = 'No hubo conexión. Intente de nuevo o escríbanos por WhatsApp.'; err.hidden = false;
      });
  });
})();
